"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Vue, Component, PropSync, Ref } from "vue-property-decorator";
export let ControllerComponent = class extends Vue {
  init() {
  }
  get $controller() {
    return this._controller;
  }
};
__decorateClass([
  PropSync("controller")
], ControllerComponent.prototype, "_controller", 2);
ControllerComponent = __decorateClass([
  Component
], ControllerComponent);
export let DrawerComponent = class extends ControllerComponent {
  created() {
    this.$nextTick(() => {
      document.body.appendChild(this.$el);
      this._drawer.$on("close", () => {
        if (document.body.hasChildNodes()) {
          document.body.removeChild(this.$el);
        }
      });
    });
  }
  show() {
    this._drawer.show();
  }
  close() {
    this._drawer.close();
  }
};
__decorateClass([
  Ref("_drawer")
], DrawerComponent.prototype, "_drawer", 2);
DrawerComponent = __decorateClass([
  Component
], DrawerComponent);
export let DialogComponent = class extends ControllerComponent {
  created() {
    this.$nextTick(() => {
      document.body.appendChild(this.$el);
      this._dialog.$on("close", () => {
        if (document.body.hasChildNodes()) {
          document.body.removeChild(this.$el);
        }
      });
    });
  }
  show() {
    this._dialog.show();
  }
  close() {
    this._dialog.close();
  }
};
__decorateClass([
  Ref("_dialog")
], DialogComponent.prototype, "_dialog", 2);
DialogComponent = __decorateClass([
  Component
], DialogComponent);
